import * as DateFns from 'date-fns';
import {
  cloneObject,
  isJustFinished,
  routeToSpecificScope, routeToViewPracticeGameFilterForceScope,
  routeToViewPracticeGamePageScope
} from '../../helpers/helpersts';

import * as TYPES from '../types';
import { addLoadingFlag, changeMessageLoading, subLoadingFlag } from './loading';
import { setGameMeta } from './gameMeta';
import { requestData } from '../../config/services/datasets';
import { SERVER } from '../../config/server.config';
import {
  paramBuilder,
  reduceObjectSize,
  setArrayFromIndex,
  unZipBase64String,
  getTeamData,
  generatorHandler,
  cleanControllerSet,
  isSafeImageUrl
} from '../../helpers/helpers';
import { changeLiveFetchFlag } from './flags';
import { getPractice } from './manage';

import {
  FORMAT_DATE_ROUTE,
  FUTURE,
  FUTURE_PRACTICE,
  GAME,
  LIVE,
  LIVE_PRACTICE, MESSAGES,
  METRICS_KEYS,
  PAST,
  PAST_GAME, PAST_PRACTICE, PLAYERS_DATA, SCOPE,
  UNASSIGNED,
  CONTROLLER_SET,
  TIMES_SHOULD_FETCH,
  SAME_DAY_ERROR_MESSAGE,
  DEFAULT_ERROR_MESSAGE,
  BLINKS_MEMORY_LIMIT,
  METRICS_CONTROLLER_SET,
  LEAGUES,
  DEFAULT_FIELD,
} from '../../config/constants';
import { loadEvents } from './events';
import { catchError } from '../../helpers/services';

export const replaceHighlightsDataEvent = (gameId, highlights, teamOfInterest) => {
  return {
    type: TYPES.REPLACE_HIGHLIGHTS_DATA_EVENT,
    gameId,
    highlights,
    teamOfInterest
  };
};

export const replaceZonesThresholdsDataEvent = (gameId, zones, teamOfInterest) => {
  return {
    type: TYPES.REPLACE_ZONES_THRESHOLD,
    gameId,
    zones,
    teamOfInterest
  };
};

export const replacePlayersDataEvent = (gameId, players, teamOfInterest) => {
  return {
    type: TYPES.REPLACE_PLAYERS_DATA_EVENT,
    gameId,
    players,
    teamOfInterest
  };
};

export const replacePlayersSessionsDataEvent = (gameId, playersSessions) => {
  return {
    type: TYPES.REPLACE_PLAYERS_SESSIONS_DATA_EVENT,
    gameId,
    playersSessions
  };
};

///////////////////////////
export const updateMetaDataEvent = (gameId, meta, isGame) => {
  return {
    type: TYPES.UPDATE_META_DATA_EVENT,
    gameId,
    meta,
    isGame
  };
};

export const updateLiveAlertsEvent = (gameId, alerts) => {
  return {
    type: TYPES.UPDATE_LIVE_ALERTS_EVENT,
    gameId,
    alerts
  };
};

export const updatePracticesDataEvents = practices => {
  return {
    type: TYPES.UPDATE_PRACTICES_DATA_EVENTS,
    practices
  };
};

export const updateHighlightsDataEvent = (gameId, highlights) => {
  return {
    type: TYPES.UPDATE_HIGHLIGHTS_DATA_EVENT,
    gameId,
    highlights
  };
};

export const updatePlayersDataEvent = (gameId, highlights) => {
  return {
    type: TYPES.ADD_PLAYERS_DATA_EVENT,
    gameId,
    highlights
  };
};

export const updatePracticeStartTime = (gameId, data) => {
  return {
    type: TYPES.UPDATE_PRACTICE_START_TIME,
    gameId,
    manage: data
  };
};

const getPracticeBlinks = (practiceId, blinks) => {
  return {
    type: TYPES.GET_PLAYER_BLINKS,
    practiceId,
    blinks
  };
};

const updateFetchStatus = (isFetching, reqSecs, practiceId) => {
  return {
    type: TYPES.ARE_TRACKS_FETCHING,
    isFetching,
    practiceId,
    reqSecs
  };
};

export const editPracticeStartTime = (practice, gameId, id, league, loader) => {
  const body = {};
  // object building START
  const cleanDrills = practice.drills ? practice.drills.map(drill => {
    if (drill.drillId) {
      delete drill.drillId;
    }
    return drill;
  }) : [];
  for (const key in practice) {
    if (practice.hasOwnProperty(key)) {
      const stringKey = key.toString();
      if (stringKey !== 'drills') {
        body[stringKey] = practice[stringKey];
      } else {
        body[stringKey] = cleanDrills;
      }
    }
  }
  // object building FINISH
  const request = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(body)
  };

  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    if (loader) {
      dispatch(addLoadingFlag(scope));
    }
    const response = await fetch(SERVER.MANAGE_UPDATE(practice._id, practice.teamId, league), request);
    if (!response.ok) {
      throw Error(response.statusText);
    }
    const responseJson = await response.json();
    if (responseJson) {
      dispatch(updatePracticeStartTime(gameId, responseJson.results[0]));
    }
    dispatch(getPractice(gameId, id, league));

    //cargar schedule del mes de esta practica
    if (loader) {
      dispatch(subLoadingFlag(scope));
    }
  };
};

export const updateDateEvent = (gameId, data) => {
  return async (dispatch, getState) => {
    if (data.meta) {
      dispatch(updateMetaDataEvent(gameId, data.meta));
    }
    if (data.highlights) {
      dispatch(updateHighlightsDataEvent(gameId, data.highlights));
    }
    if (data.players) {
      dispatch(updatePlayersDataEvent(gameId, data.players));
    }
  };
};

export const loadDataEventsOnLocalStorage = (gameId) => {
  return dispatch => {
    const reducer = 'dataEvents';
    const recoveredStore = JSON.parse(localStorage.getItem('store')) || {};
    if (recoveredStore[reducer] && recoveredStore[reducer][gameId]) {
      dispatch(updateDateEvent(gameId, recoveredStore[reducer][gameId]));
    }
  };
};
///////////////////////////
// Velocity Graph of player modals
export const replaceVelocityGraph = (gameId, playerId, velocityGraphData) => {
  return {
    type: TYPES.REPLACE_VELOCITY_GRAPH_DATA,
    gameId, playerId, velocityGraphData
  };
};

export const replacePlayersDataBallMetricsEvent = (gameId, players, teamId) => {
  return {
    type: TYPES.REPLACE_PLAYERS_BALL_METRICS_DATA_EVENT,
    gameId,
    players,
    teamOfInterest: teamId
  };
};
export const replacePlayersDataByZoneBallMetricsEvent = (gameId, data, teamId) => {
  return {
    type: TYPES.REPLACE_PLAYERS_BALL_METRICS_DATA_BY_ZONE_EVENT,
    gameId,
    data,
    teamOfInterest: teamId
  };
};

export const replaceModalPlayerData = (gameId, playerId, modalPlayer) => {
  return {
    type: TYPES.REPLACE_MODAL_PLAYER_DATA,
    gameId,
    playerId,
    modalPlayer
  };
};

export const replaceBallMetricsModalPlayerData = (gameId, playerId, modalBallMetric) => {
  return {
    type: TYPES.REPLACE_BALL_METRICS_MODAL_PLAYER_DATA,
    gameId,
    playerId,
    modalBallMetric
  };
};
export const getHomeTeam = (meta) => {
  return (
    meta.homeTeam.teamId ?
      getTeamData(
        meta.homeTeam.teamId,
        (meta.gameType &&
        (meta.gameType.substr(0, 4) === 'ncaa' || meta.gameType === 'PRO') ?
          'ncaa' : 'nfl')
      ) : meta.gameType.substr(0, 4) === 'ncaa' ? (
        {
          color: { text: '#000000', line: '#BB0000' },
          league: 'ncaa-fbs',
          teamAbbr: 'OSU',
          teamAbbrName: 'OSU',
          teamId: '194',
          teamName: 'Ohio State Buckeyes',
          teamNick: 'OSU'
        }
      ) : {
        color: { text: '#000000', line: '#BB0000' },
        league: 'ncaa-fbs',
        teamAbbr: 'CC',
        teamAbbrName: 'CC',
        teamId: null,
        teamName: '',
        teamNick: ''
      }
  );
};

export const getAwayTeam = (meta) => {
  return (
    meta.visitorTeam.teamId ?
      getTeamData(
        meta.visitorTeam.teamId,
        (meta.gameType &&
        (meta.gameType.substr(0, 4) === 'ncaa' || meta.gameType === 'PRO') ?
          'ncaa' : 'nfl')
      ) : meta.gameType && meta.gameType.substr(0, 4) === 'ncaa' ? (
        {
          color: { text: '#BB0000', line: '#000000' },
          league: 'ncaa-fbs',
          teamAbbr: 'OSU',
          teamAbbrName: 'OSU',
          teamId: '00',
          teamName: 'Ohio State Buckeyes',
          teamNick: 'OSU'
        }
      ) : {
        color: { text: '#000000', line: '#BB0000' },
        league: 'ncaa-fbs',
        teamAbbr: 'CC',
        teamAbbrName: 'CC',
        teamId: null,
        teamName: '',
        teamNick: ''
      }
  );
};

const getGameMeta = (meta) => {
  return {
    gameId: meta.gameId,
    homeTeam: {
      teamId: meta.homeTeam.teamId,
      nick: meta.homeTeam.nick,
      totalWins: meta.homeTeam.totalWins,
      totalLoss: meta.homeTeam.totalLoss,
      totalTies: meta.homeTeam.totalTies,
      pointTotal: meta.homeTeam.pointTotal,
    },
    visitorTeam: {
      teamId: meta.visitorTeam.teamId,
      nick: meta.visitorTeam.nick,
      totalWins: meta.visitorTeam.totalWins,
      totalLoss: meta.visitorTeam.totalLoss,
      totalTies: meta.visitorTeam.totalTies,
      pointTotal: meta.visitorTeam.pointTotal,
    },
  };
};
///
export const toMetaDataEvents = (practice) => {
  let type = practice.type === GAME ? PAST_GAME : (practice.status === LIVE ? LIVE_PRACTICE : (practice.status === FUTURE ? FUTURE_PRACTICE : (practice.status === PAST ? PAST_PRACTICE : null)));
  if (!type) {

    if ((practice.start && practice.end) && (practice.end > practice.start)) {
      type = PAST_PRACTICE;
    } else {

      if (practice.stepIndex) {
        if (practice.stepIndex === 2) {
          type = PAST_PRACTICE;
        } else {
          type = LIVE_PRACTICE;
        }
      } else {
        type = FUTURE_PRACTICE;
      }
    }
  }
  const meta = {
    _id: practice._id,
    gameId: (practice.gameId === UNASSIGNED ? practice._id : practice.gameId) || practice.dsid,
    startTime: practice.startTime || practice.start, // practice.start for manage requests
    endTime: practice.endTime || practice.end, // practice.end for manage requests
    intensity: practice.intensity,
    name: practice.name,
    roofType: practice.rooftype || practice.roofType,
    score: practice.score,
    homeTeam: practice.homeTeamId || practice.teamId ? {
      teamId: practice.homeTeamId ? practice.homeTeamId : practice.teamId
    } : {},
    visitorTeam: practice.awayTeamId === 'undefined' ? {} : practice.awayTeamId || practice.visitorTeamId ? {
      teamId: practice.awayTeamId || practice.visitorTeamId
    } : {},
    type,
    // for live
    currentDrill: practice.currentDrill,
    currentDrillIndex: practice.currentDrillIndex,
    drills: practice.drills,
    league: practice.league,
    gameType: practice.league !== LEAGUES.NCAA? practice.gameType : 'ncaa',
    datasetRefId: practice.dataset_ref_id
  };
  if (meta.type === PAST_GAME) {
    const homeTeam = getHomeTeam(meta);
    const awayTeam = getAwayTeam(meta);
    meta.homeTeam.data = homeTeam;
    meta.visitorTeam.data = awayTeam;
  }
  const cleanMeta = {};
  Object.keys(meta).forEach((key) => {
    if (typeof meta[key] !== 'undefined') {
      cleanMeta[key] = meta[key];
    }
  });
  return cleanMeta;
};

export const toDataEvents = (practice) => {
  return {
    meta: toMetaDataEvents(practice),
    highlights: {
      sessionNumber: practice.sessionNumber,
      sessionInfo: practice.sessionInfo,
      aveMaxSpeedMPH: practice.aveMaxSpeedMPH,
      aveMaxSpeedYPM: practice.aveMaxSpeedYPM,
      aveMaxSustainedSpeedMPH: practice.aveMaxSustainedSpeedMPH,
      aveMaxSustainedSpeedYPM: practice.aveMaxSustainedSpeedYPM,
      totalAveDist: practice.totalAveDist
    }
  };
};

export const loadPastDataEventPerformance = (eventId, teamId, withLoader, teamGameIds, isFirstCallGame, listOfPlayersExcluded, isMobile) => { // gameid = dsid = eventId = id
  return async (dispatch, getState) => {
    const teamOfInterest = teamGameIds && ((isFirstCallGame ? teamGameIds.homeTeamId : teamGameIds.awayTeamId));
    const dataScope = teamOfInterest ? ('data:' + teamOfInterest) : 'data';
    const emptyPlayers = !getState().dataEvents[eventId] || !getState().dataEvents[eventId][dataScope] || !getState().dataEvents[eventId][dataScope].players || 
    getState().dataEvents[eventId][dataScope].players.length === 0;

    const path = getState().router.location.pathname;
    let practiceGamePageScope = routeToViewPracticeGamePageScope(path);
    if (!practiceGamePageScope) {
      return;
    }
    let awayLoaderScope;
    if (teamOfInterest) {
      const gamePath = path.split('/');
      gamePath[4] = teamGameIds.homeTeamId;
      practiceGamePageScope = routeToViewPracticeGamePageScope(gamePath.join('/'));
      gamePath[4] = teamGameIds.awayTeamId;
      awayLoaderScope = routeToViewPracticeGamePageScope(gamePath.join('/'));
    }
    if ((emptyPlayers || withLoader)) {
      if (teamOfInterest) {
        if (isFirstCallGame) {
          dispatch(addLoadingFlag(practiceGamePageScope));
          dispatch(addLoadingFlag(awayLoaderScope));
        }
      } else {
        dispatch(addLoadingFlag(practiceGamePageScope));
        dispatch(addLoadingFlag(SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS.PAGE));
      }
    }

    const filterScope = routeToViewPracticeGameFilterForceScope(path);
    const params = getState().filters[filterScope] ? cloneObject(getState().filters[filterScope]) : {};
    params.includePlayer = 'yes';
    params.teamId = teamId;
    let results;
    let resultsJson;
    if (teamOfInterest) { // game
      params.teamOfInterest = teamOfInterest;
      params.teamId = teamOfInterest;
        resultsJson = await fetch(SERVER.DATAACCESS_HIGHLIGHT(eventId) + '?' + paramBuilder(params))
                    .then((response)=>response.json());
        results = resultsJson.results;
    } else { // practice
      if (params.dateRange && params.dateRange.isUseSameIntensity &&
        getState().dataEvents[eventId] && getState().dataEvents[eventId].meta && getState().dataEvents[eventId].meta.intensity) {
        params.compIntensity = getState().dataEvents[eventId].meta.intensity;
      }
      if (params.dateRange && params.dateRange.includeGamesInComparisonAvg) {
        params.prevGames = 'yes';
      }
      if(listOfPlayersExcluded){
        results = await requestData(SERVER.DATAACCESS_HIGHLIGHT(eventId) + '?' + paramBuilder(params)+`&excludePlayers=${listOfPlayersExcluded}`);
      }else{
        results = await requestData(SERVER.DATAACCESS_HIGHLIGHT(eventId, isMobile) + '?' + paramBuilder(params));
      }
    }

    if (results && results[0] && results[0].totals && Object.keys(results[0].totals).length > 0) { // HIGHLIGHTS
      dispatch(replaceHighlightsDataEvent(eventId, results[0].totals, teamOfInterest));
    }
    if (results && results[0] && results[0].zones && Object.keys(results[0].zones).length > 0) { // ZONES
      dispatch(replaceZonesThresholdsDataEvent(eventId, results[0].zones, teamOfInterest));
    }
    if (results && results[0] && results[0].entityData && results[0].entityData.length > 0) { // PLAYERS
      const players = results[0].entityData.map((entity) => {
        const metrics = {};
        const id = Object.keys(entity)[0];
        METRICS_KEYS.forEach((key) => {
          metrics[key[0]] = Number.isNaN(entity[id][key[0]]) ? -1 : entity[id][key[0]];
        });
        return {
          id: id,
          esbId: entity[id].eid ? entity[id].eid : '', // to change
          name: entity[id].name,
          position: entity[id].position,
          positionGroup: entity[id].positionGroup,
          nid: entity[id].key, // nid: data ? data[key].nid : '',
          teamId: entity[id].teamId ? entity[id].teamId : teamId,
          jerseyNumber: entity[id].jersey,
          metrics
        };
      });
      dispatch(updateMetaDataEvent(eventId, { [routeToViewPracticeGamePageScope(path)]: PLAYERS_DATA.PAST }));
      dispatch(replacePlayersDataEvent(eventId, players, teamOfInterest));
    } else { // fail the request or empty players
      if (isJustFinished(getState().dataEvents[eventId].meta) && getState().dataEvents[eventId].meta.processingFetch) { // if is on the range of preprocessing make a live request for load data
        dispatch(loadLiveDataPerformance(eventId, emptyPlayers, teamId, undefined, isMobile));
      } else {
        dispatch(replacePlayersDataEvent(eventId, [], teamOfInterest));
        if (teamOfInterest) {
          if (isFirstCallGame) {
            if(resultsJson.status === `Highlights for ${eventId} not ready`){
              dispatch(changeMessageLoading(practiceGamePageScope, 'Data will be available approximately 3 hours after the conclusion of the game.'));
            }else{
              dispatch(changeMessageLoading(practiceGamePageScope, MESSAGES.EMPTY));
            }
          } else {
            if(resultsJson.status === `Highlights for ${eventId} not ready`){
              dispatch(changeMessageLoading(awayLoaderScope, 'Data will be available approximately 3 hours after the conclusion of the game.'));
            }else{
              dispatch(changeMessageLoading(awayLoaderScope, MESSAGES.EMPTY));
            } 
          }
        } else {
          dispatch(changeMessageLoading(practiceGamePageScope, MESSAGES.EMPTY));
          dispatch(changeMessageLoading(awayLoaderScope, MESSAGES.EMPTY));
        }
      }
    }

    if ((emptyPlayers || withLoader)) {
      if (teamOfInterest) {
        if (isFirstCallGame) {
          dispatch(subLoadingFlag(practiceGamePageScope));
        } else {
          dispatch(subLoadingFlag(awayLoaderScope));
        }
      } else {
        dispatch(subLoadingFlag(practiceGamePageScope));
        dispatch(subLoadingFlag(SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS.PAGE));
      }
    }
  };
};

export const loadSchedulePractice = (gameId, isMobile) => {
  return async (dispatch) => {
    const results = await requestData(SERVER.PRACTICE_SCHEDULE(gameId, isMobile));
    if (results && results[0]) {
      dispatch(updateMetaDataEvent(gameId, toMetaDataEvents(results[0])));
    }
  };
};

// loadLiveDataPerformance every 15 seconds
export const loadLiveDataPerformance = (eventId, loading, teamId, listOfPlayers, isMobile, liveMonitor) => { // tab performance, gameId = id
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToViewPracticeGamePageScope(path);
    const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    const seconds = getState().dataEvents[eventId] ?
      getState().dataEvents[eventId].meta ? DateFns.differenceInSeconds(new Date(), new Date(getState().dataEvents[eventId].meta.startTime)) : 0
      : 0;
    let results;
    if (loading) {
      dispatch(addLoadingFlag(scope));
    }
    if (getState().flags.liveFetch) {
      dispatch(changeLiveFetchFlag(false));
      params.teamId = teamId;
      params.atSecond = (params.dateRange && params.dateRange.isUseInProgressComps) ? seconds : null;
      if (params.dateRange && params.dateRange.isUseSameIntensity &&
        getState().dataEvents[eventId] && getState().dataEvents[eventId].meta && getState().dataEvents[eventId].meta.intensity) {
        params.compIntensity = getState().dataEvents[eventId].meta.intensity;
      }
      if(listOfPlayers){
        results = await requestData(SERVER.LIVE_PRACTICE_INFO(eventId) + paramBuilder(params) + `&excludePlayers=${listOfPlayers}`);
      }else{
          results = await requestData(SERVER.LIVE_PRACTICE_INFO(eventId, isMobile) + paramBuilder(params) +`${liveMonitor? '&livemonitor=yes' : ''}`);
      } 
      
      if (results) {
        //LIVE ALERTS

        if(results[3] && results[3].alerts){
          const alerts ={
            ...results[3].alerts
          };
          dispatch(updateLiveAlertsEvent(eventId, alerts));
        }

        //dataEvents.GAMEID.DATA.META
        if (results[2] && results[2].meta) {
          const meta = {
            ...results[2].meta,
            dateUpdated: results[2].meta.updateTimestamp,
            gameId: eventId,
            [routeToViewPracticeGamePageScope(path)]: PLAYERS_DATA.LIVE
          };
          if (results[1].totals.endTime) {
            meta.type = PAST_PRACTICE;
            meta.endTime = results[1].totals.endTime;
          }
          dispatch(updateMetaDataEvent(eventId, meta));
        }
        // dataEvents.GAMEID.DATA.HIGHLIGHTS
        if (results[0] && results[0].entities && results[0].entities.length &&
          results[1] && results[1].totals) {
          if (Object.keys(results[1].totals).length === 0) {
            dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
          } else {
            dispatch(replaceHighlightsDataEvent(eventId, results[1].totals));
          }
        } else {
          dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
        }
        // dataEcents.GAMEID.DATA.ZONES
        if (results[0] && results[0].entities && results[0].entities.length &&
          results[1] && results[1].zones) {
          if (Object.keys(results[1].zones).length !== 0) {
            dispatch(replaceZonesThresholdsDataEvent(eventId, results[1].zones));
          } 
        }
        // dataEvents.GAMEID.DATA.PLAYERS
        if (results[0] && results[0].entities) {
          const players = results[0].entities.map(entity => {
            const metrics = {};
            const entityId = Object.keys(entity)[0];
            METRICS_KEYS.forEach((key) => {
              metrics[key[0]] = Number.isNaN(entity[entityId][key[0]]) ? -1 : entity[entityId][key[0]];
            });
            return {
              id: entityId,
              esbId: entity[entityId].eid,
              name: entity[entityId].name,
              position: entity[entityId].position,
              positionGroup: entity[entityId].positionGroup,
              nid: entity[entityId].key, // nid: data ? data[key].nid : '',
              teamId: eventId,
              jerseyNumber: entity[entityId].jersey,
              metrics
            };
          });
          dispatch(replacePlayersDataEvent(eventId, players));
          dispatch(changeMessageLoading(scope, null));
        } else {
          dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
        }
      } else {
        dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
      }
      dispatch(changeLiveFetchFlag(true));
    }
    if (loading) {
      dispatch(subLoadingFlag(scope));
    }
  };
};

export const loadPastDataBallMetricsPerformance = (eventId, priority, teamId, isMobile) => {
  return async (dispatch, getState) => {
    if (getState().flags.pastFetch || priority) {
      const emptyPlayers = !getState().dataEvents[eventId] || !getState().dataEvents[eventId].data || !getState().dataEvents[eventId].data.playersBall || 
      getState().dataEvents[eventId].data.playersBall.length === 0;

      const path = getState().router.location.pathname;
      const scope = routeToViewPracticeGamePageScope(path);
      dispatch(addLoadingFlag(scope));
      let results;
      const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
      params.positions = [];
      if(teamId){
        results = await requestData(SERVER.PAST_PRACTICE_BALL_METRICS(eventId) + paramBuilder(params)+`&teamOfInterest=${teamId}`);
      }else{
        results = await requestData(SERVER.PAST_PRACTICE_BALL_METRICS(eventId, isMobile) + paramBuilder(params));
      }
      
      
      // TIME STAMP
      if (results && results[0] && results[0].updateTimestamp) {
        dispatch(replaceHighlightsDataEvent(eventId, {updateTimestamp: results[0].updateTimestamp}, teamId));
      }
      // SPEED ZONE
      if (results && results[0] && results[0].bfBySpeedZoneList && results[0].bfBySpeedZoneList.length) {
        dispatch(replacePlayersDataByZoneBallMetricsEvent(eventId, results[0].bfBySpeedZoneList, teamId));
      }
      // PLAYER LIST
      if (results && results[0] && results[0].playersList && results[0].playersList.length) {
        dispatch(updateMetaDataEvent(eventId, { [routeToViewPracticeGamePageScope(path)]: PLAYERS_DATA.PAST }));
        dispatch(replacePlayersDataBallMetricsEvent(eventId, results[0].playersList, teamId));
      } else {
        if (isJustFinished(getState().dataEvents[eventId].meta)) { // if is on the range of preprocessing make a live request for load data REVIEW
          dispatch(loadLiveDataBallMetricsPerformance(eventId, emptyPlayers, isMobile));
        } else {
          dispatch(replacePlayersDataBallMetricsEvent(eventId, [], teamId));
          dispatch(changeMessageLoading(scope, MESSAGES.EMPTY_BALL_FLIGHTS));
        }
      }

      dispatch(subLoadingFlag(scope));
    }
  };
};

export const loadLiveDataBallMetricsPerformance = (id, loading, isMobile) => { // tab ball
  return async (dispatch, getState) => {
    if (getState().flags.liveFetch) {
      dispatch(changeLiveFetchFlag(false));
      const path = getState().router.location.pathname;
      const scope = routeToViewPracticeGamePageScope(path);
      if (loading) {
        dispatch(addLoadingFlag(scope));
      }

      const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
      params.positions = [];
      const results = await requestData(SERVER.LIVE_PRACTICE_BALL_METRICS(id, isMobile) + paramBuilder(params));

      //TIME STAMP
      if (results && results[0] && results[0].updateTimestamp) {
        dispatch(updateMetaDataEvent(id, { dateUpdated: results[0].updateTimestamp }));
      }
      // SPEED ZONE
      if (results && results[0] && results[0].bfBySpeedZoneList && results[0].bfBySpeedZoneList.length) {
        dispatch(replacePlayersDataByZoneBallMetricsEvent(id, results[0].bfBySpeedZoneList));
      }

      // PLAYER LIST
      if (results && results[0] && results[0].playersList && results[0].playersList.length) {
        dispatch(updateMetaDataEvent(id, { [routeToViewPracticeGamePageScope(path)]: PLAYERS_DATA.LIVE }));
        dispatch(replacePlayersDataBallMetricsEvent(id, results[0].playersList));
      } else {
        dispatch(replacePlayersDataBallMetricsEvent(id, []));
        dispatch(changeMessageLoading(scope, MESSAGES.EMPTY_BALL_FLIGHTS_LIVE));
      }

      dispatch(changeLiveFetchFlag(true));
      if (loading) {
        dispatch(subLoadingFlag(scope));
      }
    }
  };
};

export const loadDataMetaGame = (gameId) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.GAME_META(gameId));
    if (results) {
      if (!results[0] || !results[0].homeTeam || !results[0].visitorTeam || !results[0].site || !results[0].score) {
        // dispatch(changeMessageLoading(scope, 'No data matches your specified criteria'));
      } else {
        // const startDate = new Date(+results[0].gameDate.substr(6, 4), +results[0].gameDate.substr(0, 2) - 1, +results[0].gameDate.substr(3, 2));
        const startDate = new Date(+results[0].ts);
        const meta = {
          gameId: results[0].gameId,
          startTime: startDate.getTime(),
          // endTime: practice.endTime,
          startDate: startDate,
          // endDate: new Date(practice.endTime),
          type: PAST_GAME,
          siteFullName: results[0].site.siteFullname,
          homeTeam: {
            teamId: results[0].homeTeam.teamId,
            nick: results[0].homeTeam.nick,
            divFullName: results[0].homeTeam.teamStanding ? results[0].homeTeam.teamStanding.divFullName : '',
            totalWins: results[0].homeTeam.teamStanding ? results[0].homeTeam.teamStanding.totalWins : 0,
            totalLoss: results[0].homeTeam.teamStanding ? results[0].homeTeam.teamStanding.totalLoss : 0,
            totalTies: results[0].homeTeam.teamStanding ? results[0].homeTeam.teamStanding.totalTies : 0,
            pointTotal: results[0].score.homeTeamScore.pointTotal
          },
          visitorTeam: {
            teamId: results[0].visitorTeam.teamId,
            nick: results[0].visitorTeam.nick,
            divFullName: results[0].visitorTeam.teamStanding ? results[0].visitorTeam.teamStanding.divFullName : '',
            totalWins: results[0].visitorTeam.teamStanding ? results[0].visitorTeam.teamStanding.totalWins : 0,
            totalLoss: results[0].visitorTeam.teamStanding ? results[0].visitorTeam.teamStanding.totalLoss : 0,
            totalTies: results[0].visitorTeam.teamStanding ? results[0].visitorTeam.teamStanding.totalTies : 0,
            pointTotal: results[0].score.visitorTeamScore.pointTotal
          }
        };
        const homeTeam = getHomeTeam(meta);
        const awayTeam = getAwayTeam(meta);
        meta.homeTeam.data = homeTeam;
        meta.visitorTeam.data = awayTeam;
        const gameMeta = getGameMeta(meta);
        dispatch(setGameMeta(gameMeta));
        dispatch(updateMetaDataEvent(meta.gameId, meta, true));
      }
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const loadPlayerModal = (gameId, playerId, teamId) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));

    const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    // string which represents the parent component filter ID
    const practiceGamePageScope = routeToViewPracticeGamePageScope(path).replace('MODAL', 'PAGE');
    const parentParams = getState().filters[practiceGamePageScope] ? JSON.parse(JSON.stringify(getState().filters[practiceGamePageScope])) : {};
    params['dateRange'] = parentParams.dateRange;
    params.entities = playerId;
    params.includePlayer = 'yes';
    params.teamId = teamId;
    if (params.dateRange && params.dateRange.isUseSameIntensity &&
      getState().dataEvents[gameId] && getState().dataEvents[gameId].meta && getState().dataEvents[gameId].meta.intensity) {
      params.compIntensity = getState().dataEvents[gameId].meta.intensity;
    }
    const results = await requestData(SERVER.PLAYER_MODAL_POST(gameId) + 'post?' + paramBuilder(params));

    if (results && results[0] && results[0].entityData && results[0].entityData[0] && results[0].entityData[0][playerId]) {
      const metrics = {};
      METRICS_KEYS.forEach((key) => {
        metrics[key[0]] = Number.isNaN(results[0].entityData[0][playerId][key[0]]) ? -1 : results[0].entityData[0][playerId][key[0]];
      });
      const data = {
        name: results[0].entityData[0][playerId].name,
        position: results[0].entityData[0][playerId].position,
        jersey: results[0].entityData[0][playerId].jersey,
        esbId: results[0].entityData[0][playerId].eid,
        teamId: results[0].entityData[0][playerId].teamId,
        metrics
      };
      dispatch(updateMetaDataEvent(gameId, { [routeToViewPracticeGamePageScope(path)]: PLAYERS_DATA.PAST }));
      dispatch(replaceModalPlayerData(gameId, playerId, data));
    } else {
      dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const loadPlayerModalLive = (gameId, playerId, teamId, loader) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    if (loader) {
      dispatch(addLoadingFlag(scope));
    }

    const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    params.entities = playerId;
    params.teamId = teamId;
    if (params.dateRange && params.dateRange.isUseSameIntensity &&
      getState().dataEvents[gameId] && getState().dataEvents[gameId].meta && getState().dataEvents[gameId].meta.intensity) {
      params.compIntensity = getState().dataEvents[gameId].meta.intensity;
    }
    const results = await requestData(SERVER.PLAYER_MODAL_LIVE(gameId) + '?' + paramBuilder(params));

    if (results && results[0] && results[0].entities && results[0].entities[0] && results[0].entities[0][playerId]) {
      const metrics = {};
      METRICS_KEYS.forEach((key) => {
        metrics[key[0]] = Number.isNaN(results[0].entities[0][playerId][key[0]]) ? -1 : results[0].entities[0][playerId][key[0]];
      });
      const data = {
        name: results[0].entities[0][playerId].name,
        position: results[0].entities[0][playerId].position,
        jersey: results[0].entities[0][playerId].jersey,
        esbId: results[0].entities[0][playerId].eid,
        teamId: results[0].entities[0][playerId].teamId,
        metrics
      };
      dispatch(updateMetaDataEvent(gameId, { [routeToViewPracticeGamePageScope(path)]: PLAYERS_DATA.LIVE }));
      dispatch(replaceModalPlayerData(gameId, playerId, data));
    } else {
      dispatch(changeMessageLoading(scope, MESSAGES.EMPTY));
    }

    if (loader) {
      dispatch(subLoadingFlag(scope));
    }
  };
};
export const getVelocityGraphData = (gameId, playerId, live) => {
  return async (dispatch) => {
    const results = await requestData(SERVER.VELOCITY_GRAPH_DATA(gameId, playerId, live));
    if (results) {
      dispatch(replaceVelocityGraph(gameId, playerId, results));
    }
  };
};

export const loadBallMetricsModal = (gameId, playerId, loader, live) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    if (loader) {
      dispatch(addLoadingFlag(scope));
    }
    const params = getState().filters[scope] ? JSON.parse(JSON.stringify(getState().filters[scope])) : {};
    const results = await requestData(SERVER.BALL_METRICS_MODAL(gameId, live) + '?players=' + playerId + '&' + paramBuilder(params));
    //const results = ballMetricsPlayer.results;
    if (results) {
      if (!results[0]) {
        dispatch(changeMessageLoading(scope, MESSAGES.EMPTY_BALL_FLIGHTS));
      } else {
        dispatch(replaceBallMetricsModalPlayerData(gameId, playerId, results));
      }
    }
    if (loader) {
      dispatch(subLoadingFlag(scope));
    }
  };
};
export const changeToLivePractice = (oldGameId, newGameId, oldDate, newDate) => {
  return async (dispatch, getState) => {
    oldDate = oldDate || new Date();
    newDate = newDate || new Date();
    // dispatch(loadEvents(true, false, true, `/schedule/month/${DateFns.format(DateFns.addMonths(new Date(oldDate), 1), FORMAT_DATE_ROUTE)}`));
    // dispatch(loadEvents(true, false, true, `/schedule/month/${DateFns.format(new Date(oldDate), FORMAT_DATE_ROUTE)}`));
    // dispatch(loadEvents(true, false, true, `/schedule/month/${DateFns.format(DateFns.subMonths(new Date(oldDate), 1), FORMAT_DATE_ROUTE)}`));
    // dispatch(loadEvents(true, false, true, `/schedule/month/${DateFns.format(new Date(newDate), FORMAT_DATE_ROUTE)}`));
    dispatch({
      type: TYPES.CHANGE_TO_LIVE_PRACTICE,
      oldGameId,
      newGameId
    });
  };
};

export const loadPlayersSession = (practiceId, startTime, teamId) => {
  return async (dispatch, getState) => {
    dispatch(addLoadingFlag(SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS.PAGE));
    const params = { dateRange: { selectedDates: [{ start: startTime, end: startTime }] }, teamId };
    const results = await requestData(SERVER.FULL_PRACTICE(practiceId) + '?' + paramBuilder(params) + '&ignorepositions=yes');
    if (results && results.length && results[1] && results[1].entities && results[1].entities[0] && results[1].entities[0][practiceId] && results[1].entities[0][practiceId]) {
      const sessionsDataPlayers = {};
      results[1].entities[0][practiceId].forEach((player) => {
        const playerId = Object.keys(player)[0];
        sessionsDataPlayers[playerId] = player[playerId].sessions.slice(1);
      });
      dispatch(replacePlayersSessionsDataEvent(practiceId, sessionsDataPlayers));
    } else {
      dispatch(changeMessageLoading(SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS.PAGE, MESSAGES.EMPTY));
    }
    dispatch(subLoadingFlag(SCOPE.VIEW.PRACTICE.PERFORMANCE.METRICS.PAGE));
  };
};

export const cleanPlayersSession = practiceId => {
  return dispatch => {
    dispatch(replacePlayersSessionsDataEvent(practiceId, {}));
  };
};


/* Practice Viewer Actions */
const setImageDimensions = (imageURL) => {
  return new Promise((resolve, reject) => {
    let safeSrc;
    if (isSafeImageUrl(imageURL)) {
      safeSrc = imageURL;
    } else if (isSafeImageUrl(DEFAULT_FIELD.image)) {
      safeSrc = DEFAULT_FIELD.image;
    } else {
      safeSrc = "";
    }
    const img = new Image();
    img.onload = () => {
      const { width, height } = img;
      resolve([width, height]);
    };
    img.onerror = () => reject(new Error('Image failed to load'));
    img.src = safeSrc;
  });
};

const decompressTrackData = async data => {
  if (data && data.results && data.results[0]) {
    const decompressedData = await unZipBase64String(data.results[0]);
    const parsedData = await JSON.parse(decompressedData);
    return parsedData;
  }
  return [];
};

export const getPracticePlayback = (startTime, endTime, practiceId, isGame) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { startTime: practiceBegin, datasetRefId, type } = state.dataEvents[practiceId].meta;
    const { hasBlinks } = state.dataEvents[practiceId].data.practiceViewer;
    const params = type === LIVE_PRACTICE || type === PAST_GAME ? '&live=true' : '';

    const controller = new AbortController();
    CONTROLLER_SET.add(controller);
    dispatch(updateFetchStatus(true, null, practiceId));

    const resp = await fetch(
      SERVER.PRACTICE_TRACK(startTime, endTime, practiceId, isGame ? practiceId : datasetRefId) + params,
      { signal: controller.signal }
    ).catch(err => catchError(err, controller.signal));
    CONTROLLER_SET.delete(controller);

    const compressedData = resp ? await resp.json() : undefined;
    const endSecs = parseInt(((endTime - practiceBegin) / 1000).toFixed(0));
    if (compressedData) {
      dispatch(updateFetchStatus(false, endSecs, practiceId));
    }

    const data = await decompressTrackData(compressedData);

    if (data && data.length && data[0].length) {
      const reqSecs = parseInt(((startTime - practiceBegin) / 1000).toFixed(0));
      const blinks = setArrayFromIndex(data, reqSecs);
      const updatedBlinks = handleBlinksToTracksPile(blinks, state.dataEvents[practiceId].data.practiceViewer.blinks);
      dispatch(getPracticeBlinks(practiceId, updatedBlinks));
    } else if (compressedData) {
      if (!hasBlinks) {
        dispatch(handleStatusCode(compressedData.code, practiceId));
      } else {
        dispatch(getPracticeBlinks(practiceId, state.dataEvents[practiceId].data.practiceViewer.blinks));
      }
    }
  };
};

const handleBlinksToTracksPile = (blinks, oldBlinks) => {
  if (oldBlinks) {
    let updatedBlinks = { ...oldBlinks, ...blinks };
    if (Object.keys(oldBlinks).length > BLINKS_MEMORY_LIMIT) {
      const reducedBlinks = reduceObjectSize(oldBlinks, 20);
      updatedBlinks = { ...reducedBlinks, ...blinks };
    }
    return updatedBlinks;
  }
  return blinks;
};

const handleStatusCode = (code, practiceId) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { type, startTime } = state.dataEvents[practiceId].meta;

    if (code === 1 || type === LIVE_PRACTICE || type === PAST_GAME || (DateFns.isToday(startTime) && type === PAST_PRACTICE)) {
      let fetchTries = 1;
      if (state.dataEvents[practiceId].data.practiceViewer.fetchTries) {
        const stateTries = state.dataEvents[practiceId].data.practiceViewer.fetchTries;
        fetchTries = type === LIVE_PRACTICE || type === PAST_GAME ? stateTries + 1 : stateTries - 1;
      } else if (type !== LIVE_PRACTICE || type !== PAST_GAME) {
        fetchTries = TIMES_SHOULD_FETCH; // 18 * 15segs = 3 minutes
      }
      if (fetchTries > 0) {
        dispatch({ type: TYPES.FETCHED_DATA_FAILED, fetchTries, practiceId });
      } else {
        const errorMsg = DateFns.isToday(startTime) ? SAME_DAY_ERROR_MESSAGE : DEFAULT_ERROR_MESSAGE;
        dispatch(noDataFoundedDispatch(errorMsg, practiceId));
      }
    } else {
      dispatch(noDataFoundedDispatch(DEFAULT_ERROR_MESSAGE, practiceId));
    }
  };
};

export const loadPracticePlayers = (practiceId, req) => {
  return async dispatch => {
    const params = req ? req : '';
    const controller = new AbortController();

    if (req) {
      // add abort controller for live practices
      CONTROLLER_SET.add(controller);
    }

    const resp = await fetch(
      SERVER.VIEWER_PLAYERS(practiceId) + params,
      { signal: controller.signal }
    ).catch(err => catchError(err, controller.signal));
    const data = resp ? await resp.json() : {};

    if (req) {
      CONTROLLER_SET.delete(controller);
    }

    if (data && data.results && data.results.length) {
      const { results } = data;
      const [players] = results;
      dispatch({ type: TYPES.GET_PLAYERS_DATA, players, practiceId });
    }
  };
};

export const livePracticePlayers = (actualTime, practiceId) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { startTime } = state.dataEvents[practiceId].meta;
    const actualSeconds = parseInt(((actualTime - startTime) / 1000).toFixed(0));
    const params = `practiceId=${practiceId}&live=true&atSecond=${actualSeconds}`;
    dispatch(loadPracticePlayers(practiceId, params));
  };
};

const metricsGenerator = generatorHandler(
  function* (practiceId, params, oldMetrics, dispatch, controller) {
    yield new Promise((resolve) => setTimeout(resolve, 1010));

    const resp = yield fetch(
      SERVER.VIEWER_PLAYERS(practiceId) + params,
      { signal: controller.signal }
    ).catch(err => catchError(err, controller.signal));
    const data = resp ? yield resp.json() : {};

    dispatch(setMetricsResults(practiceId, data, oldMetrics));
  }, () => cleanControllerSet(METRICS_CONTROLLER_SET));

export const getPlayersMetrics = (metrics, practiceId, isProcessing) => {
  return async (dispatch, getState) => {
    const state = getState();
    const { type } = state.dataEvents[practiceId].meta;
    const { metrics: oldMetrics = {} } = state.dataEvents[practiceId].data.practiceViewer;
    let requestMetrics = [];

    // delete unused metrics and get the ones that are not loaded yet (for live get all)
    Object.keys(oldMetrics).forEach(key => !metrics.includes(key) && delete oldMetrics[key]);
    if (type === LIVE_PRACTICE) requestMetrics = metrics;
    else metrics.forEach(metric => !oldMetrics[metric] && requestMetrics.push(metric));

    if (requestMetrics.length) {
      const liveParam = type === LIVE_PRACTICE || isProcessing ? 'live=true&' : '';
      const params = `${liveParam}events=yes&players=${requestMetrics.toString()}`;
      const controller = new AbortController();
      METRICS_CONTROLLER_SET.add(controller);
      metricsGenerator(practiceId, params, oldMetrics, dispatch, controller);
      METRICS_CONTROLLER_SET.delete(controller);
    }
  };
};

const setMetricsResults = (practiceId, data, oldMetrics) => {
  return dispatch => {
    if (data && data.results && data.results[0]) {
      const updatedMetrics = { ...oldMetrics, ...data.results[0] };
      dispatch({ type: TYPES.GET_PLAYERS_METRICS, metrics: updatedMetrics, practiceId });
    }
  };
};

export const setMetricCurrentSecond = (timestamp, practiceId) => {
  return (dispatch, getState) => {
    const state = getState();
    let metricSec = null;
    if (timestamp) {
      const { startTime } = state.dataEvents[practiceId].meta;
      metricSec = parseInt(((timestamp - startTime) / 1000).toFixed(0)) * 10;
    }
    dispatch({ type: TYPES.SET_METRIC_CURRENT_SEC, metricSec, practiceId });
  };
};

export const getTeamPracticeFields = (teamId, practiceId) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const pathParams = path.split('/');
    const mapPath = [pathParams[0], pathParams[1], pathParams[2], pathParams[3], 'map'].join('/');
    const specificScope = routeToSpecificScope(mapPath);
    dispatch(addLoadingFlag(specificScope));

    const resp = await fetch(SERVER.TEAM_FIELDS(teamId));
    const data = await resp.json();

    if (data && data.results && data.results.length) {
      const { results } = data;
      const [fields] = results;
      dispatch({ type: TYPES.GET_TEAM_FIELDS, fields, practiceId });
    }

    dispatch(subLoadingFlag(specificScope));
    dispatch({ type: TYPES.MAP_SHOULD_MOUNT, status: true, practiceId });
  };
};

export const getSpecificFieldImage = (teamId, practiceId, fieldIndex) => {
  return async (dispatch, getState) => {
    const state = getState();
    const path = state.router.location.pathname;
    const pathParams = path.split('/');
    const mapPath = [pathParams[0], pathParams[1], pathParams[2], pathParams[3], 'map'].join('/');
    const specificScope = routeToSpecificScope(mapPath);

    const fields = [...state.dataEvents[practiceId].data.practiceViewer.fields];
    dispatch(addLoadingFlag(specificScope));

    const resp = await fetch(SERVER.SPECIFIC_FIELD(teamId, fields[fieldIndex]._id));
    const data = await resp.json();

    if (data && data.results && data.results.length) {
      const { results } = data;
      const [image] = results;
      const dimensions = await setImageDimensions(image);
      fields[fieldIndex] = { ...fields[fieldIndex], dimensions, image };
      dispatch({ type: TYPES.GET_TEAM_FIELDS, fields, practiceId });
    }

    dispatch(subLoadingFlag(specificScope));
  };
};

export const clearPlayersTracksData = practiceId => {
  return dispatch => {
    dispatch({ type: TYPES.CLEAR_PLAYERS_TRACKS_DATA, practiceId });
  };
};

export const cleanPracticeViewerData = practiceId => {
  return dispatch => {
    dispatch({ type: TYPES.CLEAR_PRACTICE_DATA, practiceId });
  };
};

export const noDataFoundedDispatch = (errorMsg, practiceId) => {
  return dispatch => {
    dispatch({ type: TYPES.NO_DATA_FOUNDED, errorMsg, practiceId });
  };
};

export const cleanTracksDataOnUnmount = practiceId => {
  return dispatch => {
    dispatch({ type: TYPES.CLEAR_TRACKS_DATA_ON_UNMOUNT, practiceId });
  };
};
